import { EntityBase } from './EntityBase';
import { ExposureAdditionalMaterial } from './ExposureAdditionalMaterial';
import { ExposureSurvey } from './ExposureSurvey';
import { TypeExposureSurveyResponse } from './TypeExposureSurveyResponse';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class ExposureAdditionalMaterialSurvey extends EntityBase {

   /// <code> Place custom code between <code> tags
   public get bannedMaterialCaption(): string {
        return (this.bannedMaterial) ? 'Banned' : '';
    }
   /// </code>

   // Generated code. Do not place code below this line.
   exposureAdditionalMaterialSurveyId: number;
   exposureSurveyId: number;
   exposureAdditionalMaterialId: number;
   notes: string;
   bannedMaterial: boolean;
   typeExposureSurveyResponseId: number;
   originalSurveyId: number;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   exposureAdditionalMaterial: ExposureAdditionalMaterial;
   exposureSurvey: ExposureSurvey;
   typeExposureSurveyResponse: TypeExposureSurveyResponse;
}

